// import './CompetenceSearchBox.css';
import type { ISmallCompetence } from '@sharedInterfaces/IWhoIAm';
import type { AppState } from '@store/store';
import React from 'react';

import EntitySearchBox from '../EntitySearchBox/EntitySearchBox';

interface CompetenceSearchBoxProps {
    filteredAllCompetences: ISmallCompetence[];
    newCompetence: IListElement;
    allowNew?: true;
    size?: 'medium' | 'small' | 'verysmall';
    clearOnSelect?: true;
    placeholder?: string;
    setNewCompetence: (newCompetence: IListElement) => void;
}
interface IListElement {
    title: string;
    id: number;
    // otherNames: string[]
}

/**
 * CompetenceSearchBox component.
 *
 * @param {CompetenceSearchBoxProps} props - The props for the CompetenceSearchBox component.
 * @returns {JSX.Element} The rendered CompetenceSearchBox component.
 */
const CompetenceSearchBox = (props: CompetenceSearchBoxProps) => {
    return (
        <EntitySearchBox
            filteredItems={props.filteredAllCompetences}
            newItem={props.newCompetence}
            allowNew={props.allowNew}
            size={props.size}
            clearOnSelect={props.clearOnSelect}
            placeholder={props.placeholder || 'Nach Kompetenzen suchen...'}
            setNewItem={props.setNewCompetence}
            allItemsSelector={(state: AppState) => state.company.allCompetences}
        />
    );
};

export default CompetenceSearchBox;
